import type { IconSvgObject } from './types';

const ArrowRightDoubleIcon: IconSvgObject = [
  ["path", { d: "M12.5 6L18.5 12L12.5 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.5 6L11.5 12L5.50005 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowRightDoubleIcon;
